import { EventCategory } from 'api/admin/models';
import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { stateFactories, actionsHandlers } from 'store/entities/utils';
import { EntityType } from 'store/entities/types';
import * as actions from './actions';

const stateFactory = stateFactories.createInitialEntitiesStateFactory<EntityType<EventCategory>>();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const eventCategoriesReducer = createReducer<State, Actions>(initialState, {
  [actions.getEventCategories.request.type]: actionsHandlers.handleGetManyRequest,
  [actions.getEventCategories.success.type]: actionsHandlers.handleGetManySuccess,
  [actions.getEventCategories.failure.type]: actionsHandlers.handleGetManyFailure,
  [actions.getEventCategories.reset.type]: actionsHandlers.handleGetManyReset,
});

export default eventCategoriesReducer;
